module.exports = __webpack_public_path__ + "static/media/Cera-Pro-Bold.41fc75e4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/cera/Cera-Pro-Bold.woff
// module id = 165
// module chunks = 56